/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import {
  Form,
  Row,
  Col,
  Tooltip,
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import PercentageInput from 'components/PercentageInput';
import {
  DESCUENTO_DE_CALCULO_EXTERNO,
  DESCUENTO_RECURRENTE_Y_FIJO,
  DESCUENTO_RECURRENTE_Y_VARIABLE,
} from 'utils/constants';
import DescuentosRangosSalariales from 'views/Configuracion/Accesos/DescuentosRangosSalariales';
import Input from 'antd/lib/input/Input';
import DescuentosEmpleadosPercepciones from 'views/Configuracion/Accesos/DescuentosEmpleadosPercepciones';
import DescuentosConfiguracionPercepciones from 'views/Configuracion/Accesos/DescuentosConfiguracionPercepciones';
import SectionCard from 'components/SectionCard';
import SectionStepper from 'components/SectionStepper';
import Select from '../../Select';

const PASOS_DESCUENTO = [
  { key: 'descuento-paso-1', title: 'Tipo de importe' },
  { key: 'descuento-paso-2', title: 'Cálculo' },
  { key: 'descuento-paso-3', title: 'Recurrencia' },
  { key: 'descuento-paso-4', title: 'Empleado' },
  { key: 'descuento-paso-5', title: 'Recibo y acumulados' },
];

// eslint-disable-next-line react/prop-types
const DescuentoParametros = ({
  form,
  rules,
  estatusInactivo,
  estatusAutorizado,
  setDisableTabla,
  tipoDescuento,
  setAplicaPorcentaje,
  aplicaPorcentaje,
  permission,
  selectedRowKeys,
  descuentoInfo,
  disaleAplicaPorcentaje,
  setDisableAplicaPorcentaje,
  disableAplicanRangosSalariales,
  disableRequiereDatosInformativos,
}) => {
  useEffect(() => {
    const valorImporteFijo = form.getFieldValue('aplica_importe_fijo');
    setDisableTabla(!valorImporteFijo);
  }, [<Form.Item name="aplica_importe_fijo" />]);

  const flagPercepcion = 'requiere_percepcion_global';

  return (
    <Form
      layout="vertical"
      form={form}
      scrollToFirstError
      name="general"
      initialValues={{
        aplica_importe_fijo: false,
        aplica_importe_variable: false, // CAMBIADO A FALSE
        aplica_porcentaje_predeterminado_importe_variable: false,
        porcentaje_predeterminado_importe_variable: undefined,
        requiere_identificador_percepciones: false,
        requiere_identificador_deducciones: false,
        requiere_identificador_descuentos: false,
        aplica_importe_de_calculo_externo: false,
        aplica_importe_base: false,
        aplica_periodo_unico_de_descuento: false,
        aplica_no_periodos_determinados: false,
        aplica_determinacion_de_importe_fijo_de_descuento: false,
        aplica_no_de_descuento_con_que_inicia: false,
        aplica_contador_de_descuentos: false,
        es_recurrente: false, // CAMBIADO A FALSE
        aplica_cuenta_contable_del_empleado: false,
        aplica_control_de_saldos: false,
        aparece_en_recibo_el_saldo: false,
        aplica_acumulado: false, // CAMBIADO A FALSE
        aparece_en_recibo_el_acumulado: false, // CAMBIADO A FALSE
        requiere_datos_informativos: false,
        requiere_beneficiarios_externos: false,
        aplica_suspencion: false, // CAMBIADO A FALSE
        aplica_porcentaje_individual_del_empleado: false,
        aplica_descuento_para_liquidacion: false,
      }}
    >
      <SectionStepper steps={PASOS_DESCUENTO} />

      {/* 1. Tipo de importe */}
      <SectionCard
        id="descuento-paso-1"
        number={1}
        title="Tipo de importe"
        description="¿El descuento es fijo o variable?"
      >
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_importe_fijo"
            label="El Descuento es de Importe Fijo"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_importe_variable"
            label="El Descuento es de Importe Variable"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_porcentaje_predeterminado_importe_variable"
            label="Aplica % Predeterminado para Importe Variable"
            required
          >
            <Select
              trueFalse
              // disabled={tipoDescuento !== DESCUENTO_RECURRENTE_Y_VARIABLE
              //   || estatusInactivo || estatusAutorizado || disaleAplicaPorcentaje}
              onChange={(val) => {
                if (val) {
                  setAplicaPorcentaje(true);
                } else {
                  setAplicaPorcentaje(false);
                  form.resetFields(['porcentaje_predeterminado_importe_variable']);
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <PercentageInput
            name="porcentaje_predeterminado_importe_variable"
            label="% Predeterminado para Importe Variable"
          // disabled={!aplicaPorcentaje || disaleAplicaPorcentaje}
          />
          <div style={{
            marginTop: -16, marginBottom: 8, color: '#9b9b9b', fontSize: 12,
          }}
          >
            Sólo aplica si usa importe variable con % predeterminado
          </div>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_rangos_salariales"
            label="Aplican Rangos Salariales"
            hasFeedback
            initialValue={false}
          >
            <Select
              trueFalse
              onChange={(val) => {
                if (val) {
                  setDisableAplicaPorcentaje(true);
                  form.resetFields(['porcentaje_predeterminado_importe_variable']);
                  form.setFieldValue('aplica_porcentaje_predeterminado_importe_variable', false);
                } else {
                  setDisableAplicaPorcentaje(false);
                  setAplicaPorcentaje(false);
                }
              }}
            // disabled={estatusInactivo || estatusAutorizado || disableAplicanRangosSalariales}
            />
          </Form.Item>
        </Col>
        {selectedRowKeys.length && tipoDescuento === DESCUENTO_RECURRENTE_Y_VARIABLE
          && descuentoInfo?.aplica_rangos_salariales
          ? (
            <Col xs={24} sm={24} md={24}>
              <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Rangos Salariales</p>
              <div style={{ marginBottom: 0, maxHeight: '300px', overflow: 'auto' }}>
                <DescuentosRangosSalariales
                  permission={permission}
                  selected={selectedRowKeys[0]}
                  estatusAutorizadoInactivo={estatusInactivo || estatusAutorizado}
                />
              </div>
            </Col>
          ) : null}
      </SectionCard>

      {/* 2. Cálculo */}
      <SectionCard
        id="descuento-paso-2"
        number={2}
        title="Cálculo"
        description="Base, externo y periodo"
      >
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_importe_base"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Requiere Importe Base de Cálculo</span>
                <Tooltip title="Se requiere para que el sistema haga el cálculo del descuento por aplicar." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_importe_de_calculo_externo"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Aplica Cálculo Externo</span>
                <Tooltip title="Aplica para descuentos que se calculan por fuera del sistema y se cargan al mismo." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_periodo_unico_de_descuento"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Aplica Periodo Único de Descuento</span>
                <Tooltip title="El descuento se realiza en una sola nómina." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled={tipoDescuento !== DESCUENTO_DE_CALCULO_EXTERNO}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_no_periodos_determinados"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Aplica No. de Descuentos Determinados</span>
                <Tooltip title="Se requiere cuando el sistema va a calcular el monto del descuento." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_no_de_descuento_con_que_inicia"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Requiere No. de Descuento de Inicio</span>
                <Tooltip title="Para indicar en qué número de descuento inicia." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_descuento_para_liquidacion"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Aplica Descuento para Liquidación</span>
                <Tooltip title="Indica si el descuento debe ofrecerse al capturar los Descuentos de una Configuración de Liquidación." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            />
          </Form.Item>
        </Col>
      </SectionCard>

      {/* 3. Recurrencia y saldo */}
      <SectionCard
        id="descuento-paso-3"
        number={3}
        title="Recurrencia y saldo"
        description="Periodicidad y control de saldo"
      >
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="es_recurrente"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Descuento Recurrente</span>
                <Tooltip title="Se aplica descuento mientras esté vigente." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled={tipoDescuento !== DESCUENTO_DE_CALCULO_EXTERNO}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_contador_de_descuentos"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Aplica Contador de Descuentos</span>
                <Tooltip title="Lleva el control de los descuentos que tienen un número definido de descuentos." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_determinacion_de_importe_fijo_de_descuento"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Requiere Saldo Pendiente de Descuento</span>
                <Tooltip title="Aplica para descuentos que se dan de alta y ya se habían hecho descuentos anteriormente." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_control_de_saldos"
            label="Requiere Control de Saldo de Descuentos"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_suspencion"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Aplica Suspensión del Descuento</span>
                <Tooltip title="El descuento se puede suspender de manera temporal o definitiva." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
      </SectionCard>

      {/* 4. Datos del empleado */}
      <SectionCard
        id="descuento-paso-4"
        number={4}
        title="Datos del empleado"
        description="Percepciones, deducciones y cuenta contable"
      >
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_porcentaje_individual_del_empleado"
            label="Requiere % Individual del Empleado"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        {tipoDescuento === DESCUENTO_RECURRENTE_Y_VARIABLE
          ? (
            <>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="requiere_identificar_percepciones"
                  label="Requiere Identificar Percepciones del Empleado"
                  hasFeedback
                  rules={rules.required}
                  initialValue={false}
                >
                  <Select
                    trueFalse
                  // disabled={estatusInactivo || estatusAutorizado}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="requiere_identificar_deducciones"
                  label="Requiere Identificar Deducciones del Empleado"
                  hasFeedback
                  rules={rules.required}
                  initialValue={false}
                >
                  <Select
                    trueFalse
                  // disabled={estatusInactivo || estatusAutorizado}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="requiere_identificar_descuentos"
                  label="Requiere Identificar Descuentos del Empleado"
                  hasFeedback
                  rules={rules.required}
                  initialValue={false}
                >
                  <Select
                    trueFalse
                  // disabled={estatusInactivo || estatusAutorizado}
                  />
                </Form.Item>
              </Col>
            </>
          ) : null}
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_cuenta_contable_del_empleado"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Requiere Cuenta Contable del Empleado</span>
                <Tooltip title="Aplica para descuentos que representan adeudos del empleado." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_datos_informativos"
            label="Requiere Datos Informativos"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled={tipoDescuento === DESCUENTO_DE_CALCULO_EXTERNO || estatusInactivo || estatusAutorizado || disableRequiereDatosInformativos}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="requiere_beneficiarios_externos"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Aplica Beneficiarios Externos</span>
                <Tooltip title="El descuento se entrega a un tercero." placement="right">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled={(tipoDescuento !== DESCUENTO_RECURRENTE_Y_VARIABLE && tipoDescuento !== DESCUENTO_RECURRENTE_Y_FIJO) || estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name={flagPercepcion}
            label="Requiere Percepción Global"
            hasFeedback
            rules={rules.required}
            initialValue={false}
          >
            <Select
              trueFalse
            />
          </Form.Item>
        </Col>
        <Form.Item
          shouldUpdate
        >
          {({ getFieldValue }) => (
            getFieldValue(flagPercepcion) && !!selectedRowKeys.length && (
              <Row style={{ width: '100%' }}>
                <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Percepciones</p>
                <div style={{ maxHeight: '300px', overflow: 'auto', width: '100%' }}>
                  <DescuentosConfiguracionPercepciones
                    descuentoId={selectedRowKeys[0]}
                    descuentoEmpleadoAutorizadoInactivo={false}
                    isBlocked={false}
                  />
                </div>
              </Row>
            ))}
        </Form.Item>
      </SectionCard>

      {/* 5. Recibo y acumulados */}
      <SectionCard
        id="descuento-paso-5"
        number={5}
        title="Recibo y acumulados"
        description="Qué se muestra en el recibo de nómina"
      >
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aparece_en_recibo_el_saldo"
            label="Aparece en el Recibo el Saldo"
            rules={rules.required}
            hasFeedback
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_acumulado"
            label="Requiere Acumulado de Descuentos"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aparece_en_recibo_el_acumulado"
            label="Aparece en el Recibo el Acumulado"
            rules={rules.required}
            hasFeedback
          >
            <Select
              trueFalse
            // disabled
            />
          </Form.Item>
        </Col>
      </SectionCard>
    </Form>
  );
};

export default DescuentoParametros;
